var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgMyContractSkeletonMobile = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "aria-hidden": "true",
  viewBox: "0 0 335 839"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "url(#my-contract-skeleton-mobile_svg__b)",
  clipPath: "url(#my-contract-skeleton-mobile_svg__a)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 335,
  height: 50,
  rx: 25
}), /*#__PURE__*/React.createElement("rect", {
  width: 335,
  height: 50,
  y: 74,
  rx: 5
}), /*#__PURE__*/React.createElement("rect", {
  width: 335,
  height: 35.5,
  y: 156,
  rx: 5
}), /*#__PURE__*/React.createElement("rect", {
  width: 335,
  height: 35.5,
  y: 201.5,
  rx: 5
}), /*#__PURE__*/React.createElement("rect", {
  width: 335,
  height: 35.5,
  y: 247,
  rx: 5
}), /*#__PURE__*/React.createElement("rect", {
  width: 335,
  height: 35.5,
  y: 292.5,
  rx: 5
}), /*#__PURE__*/React.createElement("rect", {
  width: 335,
  height: 479,
  y: 360,
  rx: 5
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "my-contract-skeleton-mobile_svg__b",
  x1: 0,
  x2: 1,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#fff"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "stop-color",
  dur: "1s",
  repeatCount: "indefinite",
  values: "white; #F7F7F7; white;"
})), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F7F7F7"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "stop-color",
  dur: "1s",
  repeatCount: "indefinite",
  values: "#F7F7F7; white; #F7F7F7;"
})), /*#__PURE__*/React.createElement("animateTransform", {
  attributeName: "gradientTransform",
  dur: "3s",
  from: "0 0 0",
  repeatCount: "indefinite",
  to: "0 0 0",
  type: "translate"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "my-contract-skeleton-mobile_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h335v839H0z"
})))));
export { SvgMyContractSkeletonMobile as ReactComponent };
export default __webpack_public_path__ + "static/media/my-contract-skeleton-mobile.86e411c14e1d0c188fae.svg";